import { DropdownOption } from "@finbackoffice/site-core";
import { ConfigContextV2 } from "contexts";
import Translate from "components/base/translate/Translate";
import { FC, useContext } from "react";
import classNames from "classnames";
import styles from "./advanced-sidebar-footer.module.sass";

type Props = {
    format: DropdownOption;
};

const AdvancedSidebarOddsFormat: FC<Props> = ({ format }) => {
    const { changeOddFormat, oddFormat } = useContext(ConfigContextV2);

    const onOddsFormatChangeHandler = (val: string) => {
        changeOddFormat(val);
    };

    return (
        <div
            onClick={() => onOddsFormatChangeHandler(format.value)}
            className={classNames(oddFormat === format.value && styles.selected)}>
            {typeof format.label === "string" && <Translate tid={format.label} />}
        </div>
    );
};

export default AdvancedSidebarOddsFormat;
